import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DEFAULT_LANGUAGE } from '../../i18n';

export default function GuestRoute() {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { lang } = useParams();
  const currentLang = lang || DEFAULT_LANGUAGE;

  if (isAuthenticated) {
    return <Navigate to={`/${currentLang}/dashboard`} replace />;
  }

  return <Outlet />;
}
